/**
 * URL path segments for the Vercel Bot read-only API.
 * Matches Specsheet style: camelCase keys, kebab-case path values (see adminSubRoute).
 *
 * Full paths (prod): https://coreapi.thespecsheet.com/vercelbot/...
 */
export const vercelBotSubRoute = {
  /** GET /vercelbot/campaigns — renewal snapshot campaigns by org + date range */
  campaigns: "campaigns",
  /** GET /vercelbot/users — org members + workspace roles for decks */
  users: "users",
  /** GET /vercelbot/publishers/resolve — mediaOwner publisher id by vendor name */
  publishersResolve: "publishers/resolve",
  /** GET /vercelbot/claimed-campaigns — claimed ext campaigns for a publisher */
  claimedCampaigns: "claimed-campaigns",
  /**
   * GET /vercelbot/ext-campaigns?code=&publisher=
   * Exact media-owner contract lookup for Intercom/Tam (max 10 rows).
   */
  extCampaigns: "ext-campaigns",
} as const;

export type VercelBotRoutes =
  | {
      sub: (typeof vercelBotSubRoute)["campaigns"];
      method?: "Get";
    }
  | {
      sub: (typeof vercelBotSubRoute)["users"];
      method?: "Get";
    }
  | {
      sub: (typeof vercelBotSubRoute)["publishersResolve"];
      method?: "Get";
    }
  | {
      sub: (typeof vercelBotSubRoute)["claimedCampaigns"];
      method?: "Get";
    }
  | {
      sub: (typeof vercelBotSubRoute)["extCampaigns"];
      method?: "Get";
    };
